<template>
    <modal
        v-if="show"
        :form="form"
        :type="'is-primary'"
        :size="'is-small'"
        :title="title()"
        :submit-text="'Request Access'"
        :success-text="'Request sent to your administrator!'"
        @submit="save"
        @closed="closed"
    >
        {{ description() }}
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import Form from 'core/Form';
import stores from 'store/modules';

export default {
    props: {
        show: { type: Boolean, default: false },
    },

    data() {
        return {
            form: new Form({}, false),
        };
    },

    computed: {
        ...mapState(stores.User, ['showModalChangeRoleRequest', 'customModalChangeRoleText']),
    },

    methods: {
        closed() {
            this.$emit('closed');
            this.form.reset();
        },

        title() {
            if (this.customModalChangeRoleText?.title) {
                return this.customModalChangeRoleText?.title;
            }

            return 'Feature Unavailable on Observer Role';
        },

        description() {
            if (this.customModalChangeRoleText?.description) {
                return this.customModalChangeRoleText?.description;
            }

            return 'Please request access from your administrator.';
        },

        save() {
            this.$store.dispatch('updateUsersChangeRoleRequest', this.form);
        },
    },
};
</script>
